import React from "react";
import css from './Alert.module.scss';


/**
 * @class
 *
 * An accordion component -- provides an expandable details-summary view.
 * Clicking on the header expands/collapses the content section.
 *
 * @prop header (React Markup): Markup for the header/summary.
 * @prop content (React Markup): Markup for the content/details section.
 *
 * @example
 *  // markup:
 *  <Alert showAlert={this.state.shouldShowAlert}>{this.state.alertMessage}</Alert>
 *
 *  // logic to trigger alert:
 *  state = {
 *      shouldShowAlert: false,
 *      alertMessage: ''
 *   };
 *
 *  myFunction = () => {
 *      this.setState({
 *          shouldShowAlert: true,
 *          alertMessage: 'Lorem ipsum dolor sit amet, consectetur adipisicing.'
 *      });
 *      // hide the alert after 5.5 seconds:
 *      setTimeout(() => {
 *          this.setState({shouldShowAlert: false});
 *      }, 5500);
 *  };
 */
const Alert = (props) => {
    return (
        <div className={props.showAlert ? css.Alert : `${css.Alert} ${css.Hidden}`}>{ props.children }</div>
    );
};

export default Alert;
